import { Controller } from "@hotwired/stimulus"
import $ from 'jquery';

export default class extends Controller {
  static targets = [ "menu", "key", "itemId", "submit", "output" ]

  initialize() {
    if (this.hasMenuTarget) {
      window.addEventListener('click', (e) => {
        if (!this.menuTarget.contains(e.target)){
          this.menuTarget.classList.remove('mdc-menu-surface--open');
        }
      });
    }

  }

  listItem(data, type) {

    if (type == "countries") {
      return `<li class="mdc-list-item" data-value="${data.id}" data-name="${data.name}" data-action="click->autocomplete#setItem"><span class="mdc-list-item__ripple"></span><div class="mdc-list-item__text">${data.name}</div></li>`;
    } else if (type == "innovations") {
      return `<li class="mdc-list-item" data-value="${data.root_id}" data-name="${data.name}" data-action="click->autocomplete#setItem"><span class="mdc-list-item__ripple"></span><div class="mdc-list-item__text">${data.name}</div></li>`;
    } else if (type == "users") {
      return `<li class="mdc-list-item" data-value="${data.id}" data-name="${data.name}" data-action="click->autocomplete#setItem"><span class="mdc-list-item__ripple"></span><div class="mdc-list-item__text"><div class="mdc-list-item__primary-text">${data.name}</div><div class="mdc-list-item__secondary-text">${data.info || ""}</div></div></li>`;
    } else if (type == "categories") {
      return `<li class="mdc-list-item" data-value="${this.escapeAttribute(data.id)}" data-name="${this.escapeAttribute(data.name)}" data-action="click->autocomplete#setItem"><span class="mdc-list-item__ripple"></span><div class="mdc-list-item__text">${this.escapeHtml(data.name)}</div></li>`;
    } else {
      return ``;
    }

  }

  setItem(event) {
    if (this.hasItemIdTarget) {
      this.itemIdTarget.value = event.currentTarget.dataset.value;
    }

    this.keyTarget.value = event.currentTarget.dataset.name;
    this.outputTarget.innerHTML = "";

    if (this.hasMenuTarget) {
      this.menuTarget.classList.remove('mdc-menu-surface--open');
    }

    this.submitTarget.disabled = false;

    if (this.keyTarget.dataset.submitOnSelect === "true") {
      this.keyTarget.closest("form").requestSubmit();
    }
  }

  getObjects(event) {
    let _this = this;

    let key = this.keyTarget.value;
    
    if (this.hasItemIdTarget) {
      this.itemIdTarget.value = null;
      this.submitTarget.disabled = true;
    }

    $.ajax({
      data: {search: key , targets: JSON.parse(this.keyTarget.dataset.targets)},
      dataType:'json',
      type:'get',

      url: "/en/edit-autocomplete.json",
      success : function(data, textStatus, jqXHR) {
                  _this.setList(data);
                }
    });
  }

  setList(data) {
    let _this = this;
    var target = JSON.parse(this.keyTarget.dataset.targets)[0];
    var list = "";

    data[target].forEach(function (item, index) {
      list += _this.listItem(item, target)
    });

    const key = this.keyTarget.value.trim();
    const hasExactMatch = data[target].some((item) => item.name.trim().toLocaleLowerCase() === key.toLocaleLowerCase());

    if (target === "categories" && this.keyTarget.dataset.createOption === "true" && key.length > 0 && !hasExactMatch) {
      list += `<li class="mdc-list-item" data-name="${this.escapeAttribute(key)}" data-action="click->autocomplete#createItem"><span class="mdc-list-item__ripple"></span><div class="mdc-list-item__text">Create “${this.escapeHtml(key)}”</div></li>`;
    }
    
    this.outputTarget.innerHTML = list;

    if (this.hasMenuTarget) {
      if (list.length > 0) {
        this.menuTarget.classList.add('mdc-menu-surface--open');
      } else {
        this.menuTarget.classList.remove('mdc-menu-surface--open');
      }
    }

  }

  createItem(event) {
    this.keyTarget.value = event.currentTarget.dataset.name;
    this.keyTarget.closest("form").requestSubmit();
  }

  escapeHtml(value) {
    return String(value).replace(/[&<>"]/g, (character) => ({"&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;"})[character]);
  }

  escapeAttribute(value) {
    return this.escapeHtml(value).replace(/'/g, "&#39;");
  }

}
